export const toast_Time_out = 6000;

/** Currency symbol for billing display (admin4.0). */
export const CurrencySymbol = "₹";

/** Transaction/reference number validation (admin4.0 Billing). */
export const TXN_MSG_MAX = "Minimum Reference Number should be 4 digit";
export const TXN_MSG_MAX_LEN = 4;

/** Default demographics field order for layout configuration (from admin4.0). */
export const Demo_Layout_Default_JSON = [
  { id: 1, field_name: "first_name", label: "First Name", is_active: true, is_default: true },
  { id: 2, field_name: "age", label: "Age", is_active: true, is_default: true },
  { id: 3, field_name: "gender", label: "Gender", is_active: true, is_default: true },
  { id: 4, field_name: "dob", label: "Date of Birth", is_active: true, is_default: false },
  { id: 5, field_name: "mobile_no", label: "Mobile no", is_active: true, is_default: false },
  { id: 6, field_name: "title", label: "Title", is_active: true, is_default: false },
  { id: 7, field_name: "middle_name", label: "Middle Name", is_active: true, is_default: false },
  { id: 8, field_name: "surname", label: "Surname", is_active: true, is_default: false },
  { id: 9, field_name: "address_1", label: "Address 01", is_active: true, is_default: false },
  { id: 10, field_name: "address_2", label: "Address 02", is_active: true, is_default: false },
  { id: 11, field_name: "city", label: "City", is_active: true, is_default: false },
  { id: 12, field_name: "state", label: "State", is_active: true, is_default: false },
  { id: 13, field_name: "country", label: "Country", is_active: true, is_default: false },
  { id: 14, field_name: "pin_code", label: "Pin Code", is_active: true, is_default: false },
  { id: 15, field_name: "employer_id", label: "Hospital Name", is_active: true, is_default: false },
  { id: 16, field_name: "employee_id", label: "OP / IP Number", is_active: true, is_default: false },
  { id: 17, field_name: "email_id", label: "Email ID", is_active: true, is_default: false },
  { id: 18, field_name: "marital_status", label: "Marital Status", is_active: true, is_default: false },
  { id: 19, field_name: "father_husband_name", label: "Father/Spouse Name", is_active: true, is_default: false },
  { id: 20, field_name: "father_husband_age", label: "Father/Spouse Age", is_active: true, is_default: false },
  { id: 21, field_name: "mother_name", label: "Mother's Name", is_active: true, is_default: false },
  { id: 22, field_name: "mother_age", label: "Mother's Age", is_active: true, is_default: false },
  { id: 23, field_name: "occupation", label: "Occupation", is_active: true, is_default: false },
  { id: 24, field_name: "emergency_contact_person", label: "Emergency Contact Person", is_active: true, is_default: false },
  { id: 25, field_name: "emergency_contact_mobile", label: "Emergency Mobile No", is_active: true, is_default: false },
  { id: 26, field_name: "relationship", label: "Relationship", is_active: true, is_default: false },
  { id: 27, field_name: "guardian", label: "Guardian", is_active: true, is_default: false },
  { id: 28, field_name: "old_referral_no", label: "Old / Referral No", is_active: true, is_default: false },
  { id: 29, field_name: "blood_group", label: "Blood Group", is_active: true, is_default: false },
];
